import React, { useState } from 'react';
import { useSelector } from "react-redux";
import './styles/widget-install.scss';
import { Http } from '../../../helpers/axois';
import { useToast } from '../../../helpers/commonFunction';
import { logger } from '../../../constant/winston';
import { AppState } from '../../../stateManager/store';

interface IProps {
    widgetId: string;
    orgId: string;
    is_installed: boolean;
    name: string;
    type?: string;
}

const WidgetInstall: React.FC<IProps> = ({ widgetId, is_installed, name, type = "install" }) => {
    const [install, setInstall] = useState(is_installed);
    const { SuccessToast, ErrorToast } = useToast();
    const selectedOrgId = useSelector((state: any) => state.org.selectedOrg.id)
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
      }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
      const { selectedOrg } = useSelector((state: AppState) => state.org)
      const loggedInUserId = useSelector((state: any) => {
          return state.user.data.user.id
      })
    const handleWidgetInstall = async (e: React.SyntheticEvent) => {
        e.stopPropagation();
        if ((!orgPermissions?.includes("marketplace.PublishWidget") || !orgPermissions.includes('org.View')) && loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
        return
      }
        const endpoint = `/orgs/${selectedOrgId}/store/products/${widgetId}/install`
        try {
            await Http.post(endpoint).toPromise();
            setInstall(true);
            SuccessToast(`Installed ${name}`)
        } catch (err) {
            if (err === "Forbidden") {
                ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            } else {
                ErrorToast("Failed to install widget")
            }
            logger.error(err)
        }
    }

    const handleWidgetUpdate = async (e: React.SyntheticEvent) => {
        e.stopPropagation();
        if ((!orgPermissions?.includes("marketplace.PublishWidget") || !orgPermissions.includes('org.View'))&& loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
        return
      }
        const endpoint = `/orgs/${selectedOrgId}/store/products/${widgetId}/update`
        try {
            await Http.put(endpoint).toPromise();
            SuccessToast(`Updated ${name}`)
        } catch (err) {
            if (err === "Forbidden") {
                ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            } else {
                ErrorToast("Failed to update widget")
            }
            logger.error(err)
        }
    }

    const getLabel = () => {
        if (type === "install") {
            if (is_installed || install) {
                return "Installed"
            } else {
                return "Install"
            }
        } else {
            return "Update"
        }
    }

    const handleClick = (e: React.SyntheticEvent) => {
        if (type === "install") {
            handleWidgetInstall(e)
        } else {
            handleWidgetUpdate(e);
        }
    }
    return (
        <div className="widget-install">
            <button
                data-test-id={`${getLabel()}`}
                onClick={handleClick}
                className={`${is_installed || install ? "btn-installed" : "btn-install"
                    }`}
            >
                {getLabel()}
            </button>
        </div>
    )
}

export default WidgetInstall
